import request from '../utils/request';
const querystring = require('querystring') 
//获取列表数据
export const fetchData = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMessage/selectList.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

//改变消息状态
export const updateData = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMessageMem/update.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

//删除消息
export const deleteData = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMessageMem/delete.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
}; 

 

 




